var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _rect6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIconbelumadaperusahaan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 120,
    viewBox: "0 0 133 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2554,
    cy: 60,
    r: 60,
    fill: "#F2F5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.1084,
    y: 31,
    width: 7.41171,
    height: 71.9995,
    fill: "url(#paint0_linear_1847_160224)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.637,
    y: 31,
    width: 7.41171,
    height: 71.9995,
    fill: "url(#paint1_linear_1847_160224)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1084,
    y: 33.1191,
    width: 7.41171,
    height: 37.0586,
    fill: "url(#paint2_linear_1847_160224)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108.637,
    y: 33.1191,
    width: 7.41171,
    height: 37.0586,
    fill: "url(#paint3_linear_1847_160224)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6377,
    y: 35.2344,
    width: 87.8817,
    height: 28.588,
    fill: "url(#paint4_linear_1847_160224)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0215 35.2344H60.9908L51.7837 63.8224H39.8145L49.0215 35.2344Z",
    fill: "url(#paint5_linear_1847_160224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5405 35.2344H81.1082L71.4407 63.8224H58.873L68.5405 35.2344Z",
    fill: "url(#paint6_linear_1847_160224)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6582 35.2344H101.226L91.5584 63.8224H78.9907L88.6582 35.2344Z",
    fill: "url(#paint7_linear_1847_160224)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.315 35.2344H120.284L111.077 63.8224H99.1079L108.315 35.2344Z",
    fill: "url(#paint8_linear_1847_160224)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.638184,
    y: 100.883,
    width: 127.058,
    height: 2.11763,
    fill: "url(#paint9_linear_1847_160224)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5928 72.5215H24.095L32.4027 101.11H12.2852L20.5928 72.5215Z",
    fill: "url(#paint10_linear_1847_160224)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0634 96.873H33.6243L34.5202 101.108H10.1675L11.0634 96.873Z",
    fill: "url(#paint11_linear_1847_160224)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3619 76.7563L19.9772 74.6389L24.7102 74.6387L25.3256 76.7563H19.3619Z",
    fill: "#3EE78D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.208 84.168L17.8233 82.0506L26.864 82.0504L27.4794 84.168H17.208Z",
    fill: "#3EE78D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0542 91.5797L15.6695 89.4624L29.0178 89.4621L29.6333 91.5797H15.0542Z",
    fill: "#3EE78D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.938 53.1211L16.2413 57.4244",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8774 57.4238L16.1807 53.1205",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.938 25.1211L35.2413 29.4244",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8774 29.4238L35.1807 25.1205",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 78.1211L130.24 82.4244",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.876 82.4238L130.18 78.1205",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.937 19.1211L90.2403 23.4244",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8765 23.4238L90.1797 19.1205",
    stroke: "#6CCC93",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1847_160224",
    x1: 49.052,
    y1: 90.2611,
    x2: 49.052,
    y2: 42.6696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1847_160224",
    x1: 112.581,
    y1: 90.2611,
    x2: 112.581,
    y2: 42.6696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1847_160224",
    x1: 48.4786,
    y1: 82.968,
    x2: 48.4786,
    y2: 5.64107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1847_160224",
    x1: 112.007,
    y1: 82.968,
    x2: 112.007,
    y2: 5.64107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1847_160224",
    x1: 76.5988,
    y1: 73.6892,
    x2: 76.5988,
    y2: 14.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1847_160224",
    x1: 51.082,
    y1: 58.7645,
    x2: 51.082,
    y2: 39.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1847_160224",
    x1: 70.7039,
    y1: 58.7645,
    x2: 70.7039,
    y2: 39.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1847_160224",
    x1: 90.8216,
    y1: 58.7645,
    x2: 90.8216,
    y2: 39.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1847_160224",
    x1: 110.375,
    y1: 58.7645,
    x2: 110.375,
    y2: 39.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1847_160224",
    x1: 58.4133,
    y1: 103.731,
    x2: 58.4133,
    y2: 99.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1847_160224",
    x1: 22.9893,
    y1: 96.0516,
    x2: 22.9893,
    y2: 77.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1847_160224",
    x1: 21.241,
    y1: 102.57,
    x2: 21.241,
    y2: 93.7327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211119,
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895928,
    stopColor: "#4766DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconbelumadaperusahaan);
export default __webpack_public_path__ + "static/media/profile-iconbelumadaperusahaan.65ced9ecce6c7c5000deda559c5f3a9d.svg";
export { ForwardRef as ReactComponent };